import {
  Keyboard,
  Platform,
  Pressable,
  ScrollView,
  Text,
  TextInput,
  View,
  ViewStyle,
} from "react-native";
import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import {
  color_929292,
  color_F1F1F1,
  color_2A2A2A,
  color_main,
  color_BEBEBE,
  white,
  color_333333,
} from "../../assets/style/colors";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  Str_Album,
  Str_Camera,
  Str_Emit,
  Str_Feedback,
  Str_FeedbackFail,
  Str_FeedbackImgDesc,
  Str_FeedbackImgText,
  Str_FeedbackPlaceholder1,
  Str_FeedbackPlaceholder2,
  Str_FeedbackSuc,
  Str_FeedbackText1,
  Str_FeedbackText2,
  Str_FeedbackToast1,
  Str_FeedbackToast2,
  Str_FeedbackToast3,
  Str_ImgUploadFail,
} from "../../language/string_res";
import { MainNavProps } from "../navigation/main/MainParamList";
import { feedback } from "../../net/service";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import FastImage from "react-native-fast-image";
import { showDialog } from "../../components/CommonDialog";
import { FeedbackRequest } from "../../net/request";
import {
  PickerResult,
  openCamera,
  openMultiplePicker,
} from "../../utils/PicOrCameraManager";
import { CommonBottomModal } from "../CommonBottomModal";
import { uploadImages } from "../../utils/upload";
import { ImageView } from "../../components/ImageView";
import { StyleProp } from "react-native/Libraries/StyleSheet/StyleSheet";
import { TextStyle } from "react-native/Libraries/StyleSheet/StyleSheetTypes";
import Animated, {
  Easing,
  ReduceMotion,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
  withTiming,
} from "react-native-reanimated";
import { LayoutChangeEvent } from "react-native/Libraries/Types/CoreEventTypes";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useWindowDimensions } from "react-native";
import { isNumeric, isValidEmail } from "../login/register";
import * as ImSdk from "../../../imsdk/api";
import { MessageType } from "../../constants/types";
import { MediaPreviewItem } from "../../realm/schema";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import { BottomButtonView } from "../../components/BottomButtonView";
import { fixRemoteUrl } from "../../../imsdk/api";
import { UploadKey } from "../../utils/ReactBlobUtil";

type ImageComponentsProps = {
  type: number;
  result?: PickerResult;
  margin: number;
  del?: (result?: PickerResult) => void;
  open?: (imgUrl: string) => void;
  add?: () => void;
};
const ImageComponents = (props: ImageComponentsProps) => {
  const { type, result, margin, del, open, add } = props;
  const path = result?.path ?? "";
  const filePath = path.startsWith("file://") ? path : "file://" + path;

  return (
    <View>
      {type == 0 ? (
        <Pressable
          onPress={add}
          style={{
            width: 80,
            height: 80,
            borderRadius: 4,
            borderWidth: 0.5,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "#B5B5B5",
            backgroundColor: "#EEEEEE",
          }}
        >
          <Text style={{ fontSize: 37, color: "#828282" }}>+</Text>
        </Pressable>
      ) : (
        <Pressable
          style={{ marginStart: margin, overflow: "visible" }}
          onPress={() => open?.(filePath)}
        >
          <FastImage
            source={{ uri: filePath }}
            style={{
              width: 80,
              height: 80,
              borderWidth: 0.5,
              borderColor: "#B5B5B5",
              borderRadius: 4,
            }}
          />
          <ImageView
            style={{
              position: "absolute",
              top: -16,
              end: -16,
              padding: 8,
            }}
            onClick={() => del?.(result)}
            imgStyle={{ width: 20, height: 20 }}
            source={require("../../assets/image/icon_delete.png")}
          />
        </Pressable>
      )}
    </View>
  );
};

type InputComponentsProp = {
  style?: ViewStyle;
  inputStyle?: StyleProp<TextStyle>;
  text: string;
  value: string;
  onChangeText: (text: string) => void;
  maxInputNum: number;
  placeholder: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onLayout?: (event: LayoutChangeEvent) => void;
};
const InputComponents = (props: InputComponentsProp) => {
  const {
    style,
    inputStyle,
    value,
    text,
    onChangeText,
    maxInputNum,
    placeholder,
  } = props;
  return (
    <View style={[style, { flex: 1 }]}>
      <View
        style={{ width: "100%", backgroundColor: color_F1F1F1, height: 1 }}
      />
      <View
        style={{ flexDirection: "row", marginTop: 21, alignItems: "center" }}
      >
        <Text style={{ fontSize: 15, color: color_2A2A2A }}>{text}</Text>
        <Text style={{ fontSize: 15, color: "red" }}>*</Text>
        <Text
          style={{
            fontSize: 12,
            color: color_929292,
            position: "absolute",
            end: 17,
          }}
        >
          {value.length}/{maxInputNum}
        </Text>
      </View>
      <TextInput
        placeholder={placeholder}
        editable={true}
        selectionColor={color_main}
        placeholderTextColor={color_BEBEBE}
        style={[
          { marginTop: 17, marginEnd: 16, color: color_333333 },
          inputStyle,
        ]}
        textAlign={"left"}
        value={value}
        multiline={true} //自动换行
        textAlignVertical={"top"}
        maxLength={maxInputNum}
        onChangeText={onChangeText}
      />
    </View>
  );
};

export const Feedback = ({ navigation }: MainNavProps<"Feedback">) => {
  const [images, setImages] = useState<PickerResult[]>();
  const [feedContent, setFeedContent] = useState("");
  const [feedContact, setFeedContact] = useState("");

  const openPicker = () => {
    openMultiplePicker("photo", 3 - (images?.length ?? 0)).then((r) => {
      if (r) {
        addImage(r);
      }
    });
  };

  function addImage(result: PickerResult[]) {
    if (images) {
      setImages([...images, ...result]);
    } else {
      setImages(result);
    }
  }

  function openImage(imgUrl: string) {
    if (imgUrl.length > 0) {
      const item: MediaPreviewItem = {
        type: MessageType.IMAGE,
        mid: "",
        index: 0,
        currentIndex: 0, 
        content: fixRemoteUrl(imgUrl),
      };

      navigation.navigate("MediaPreviewScreen", {
        items: [item],
        initialIndex: 0,
      });
    }
  }

  const deleteImg = (result?: PickerResult) => {
    if (!result) return;
    const newImages = images?.filter((v) => v !== result);
    setImages(newImages);
  };

  function sendFeedback() {
    if (feedContent.trim().length <= 0) {
      showToast(Str_FeedbackToast1);
      return;
    }
    const contact = feedContact.trim();
    if (contact.length <= 0) {
      showToast(Str_FeedbackToast2);
      return;
    }
    const isNum = isNumeric(contact);
    const isEmail = isValidEmail(contact);
    if (!(isNum || isEmail)) {
      showToast(Str_FeedbackToast3);
      return;
    }
    showLoading("");
    const currentAppkey = ImSdk.getInstance().CurrentAppkey();
    const body: FeedbackRequest = {
      desc: feedContent,
      contract: feedContact,
      appKey: currentAppkey,
    };
    if (images && images.length > 0) {
      uploadImage(body);
    } else {
      handleFeedback(body);
    }
  }
  const uploadImage = (body: FeedbackRequest) => {
    uploadImages(images, UploadKey.Global).then((res) => {
      if (res.responses && res.responses.length > 0) {
        body.images = res.responses.map((value) => value.url);
        handleFeedback(body);
      } else {
        showToast(Str_ImgUploadFail);
        hideLoading();
      }
    });
  };

  const handleFeedback = (body: FeedbackRequest) => {
    feedback(body)
      .then((res) => {
        if (res.code === 0) {
          hideLoading();
          showDialog({
            message: Str_FeedbackSuc,
            onConfirm: () => {
              navigation.goBack();
            },
          });
        } else {
          hideLoading();
          showToast(res.msg || Str_FeedbackFail);
        }
      })
      .catch((err) => {
        hideLoading();
        showToast(err.msg || Str_FeedbackFail);
      });
  };

  return (
    <ScreenCloseModal title={Str_Feedback}>
      <ScrollView
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps={"always"}
      >
        <View
          style={{
            backgroundColor: "white",
            paddingStart: 24,
            paddingEnd: 24,
            paddingVertical: 24,
            marginHorizontal: 24,
            marginTop: 24,
            borderRadius: 16,
            minHeight: 500,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              marginTop: 17,
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: 14, color: "black" }}>
              {Str_FeedbackImgDesc}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: color_929292,
                position: "absolute",
                end: 17,
              }}
            >
              {Str_FeedbackImgText}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginTop: 23 }}>
            {(images?.length ?? 0) < 3 && (
              <ImageComponents type={0} margin={0} add={openPicker} />
            )}
            {images?.map((item, index) => {
              return (
                <ImageComponents
                  key={index}
                  margin={(images?.length ?? 0) >= 3 && index === 0 ? 0 : 12}
                  type={1}
                  open={openImage}
                  del={deleteImg}
                  result={item}
                />
              );
            })}
          </View>

          <InputComponents
            style={{ marginTop: 26 }}
            value={feedContent}
            text={Str_FeedbackText1}
            onChangeText={setFeedContent}
            maxInputNum={100}
            inputStyle={{ height: 120 }}
            placeholder={Str_FeedbackPlaceholder1}
          />

          <InputComponents
            style={{ marginTop: 26 }}
            value={feedContact}
            onChangeText={setFeedContact}
            maxInputNum={30}
            text={Str_FeedbackText2}
            inputStyle={{ height: 70 }}
            placeholder={Str_FeedbackPlaceholder2}
          />
          <View
            style={{
              width: "100%",
              backgroundColor: color_F1F1F1,
              height: 1,
            }}
          />
        </View>
      </ScrollView>
      <BottomButtonView
        text={Str_Emit}
        onClick={sendFeedback}
        contentStyle={{ width: "70%" }}
      />
    </ScreenCloseModal>
  );
};
